import api from "../services/api";
import util from '@/services/util';
import orderUtil from '@/services/orderUtil';

const moment = require("moment");

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        order: {
            Stage: 0
        },
        orderProducts: [],
        ordersProductsComments: [],
        orderSuppliers: {
            updating: false,
            loadError: false,
            productsWithSuppliers: [],
            categoriesWithProducts: []
        },
        saving: {
            loading: false,
            error: ""
        }
    },
    getters: {
        getOrderToSave(state){
            return () => {
                let order = util.deepAssign(state.order);
                order.Products = util.deepAssign(state.orderProducts).map(oP => {
                    // Prevent unnecessary data from being sent over the network
                    return {
                        Product: {
                            ID: oP.Product.ID,
                            SellPrice: oP.Product.SellPrice,
                            CostPrice: oP.Product.CostPrice,
                            CostPerUnit: oP.Product.CostPerUnit
                        },
                        Supplier: {
                            ID: oP.Supplier.ID
                        },
                        Quantity: oP.Quantity,
                        Stock:oP.Stock
                    };
                });

                return order;
            }
        },
        getOrderProductsAndComments(state) {
            var orderProductsAndComments = [];
            orderProductsAndComments = orderProductsAndComments.concat(state.orderProducts);
            for(var i = 0; i < state.ordersProductsComments.length; i ++) {
                var ordersProductsComment = state.ordersProductsComments[i];
                var found = state.orderProducts.find(orderProduct => {
                    return orderProduct.Product.ID == ordersProductsComment.ProductID;
                })
                if(!found && ordersProductsComment && ordersProductsComment.Comments != "") {
                    let product = state.orderSuppliers.productsWithSuppliers.find(p => p.ID == ordersProductsComment.ProductID);
                    product.Comments = ordersProductsComment.Comments;
                    let category = state.orderSuppliers.categoriesWithProducts.find(c => c.ID == product.CategoryID);
                    orderProductsAndComments.push({
                        Product: product,
                        Category: category,
                        Supplier: null,
                        Quantity: null
                    });
                }
            }
            return orderProductsAndComments;
        }
    },
    mutations: {
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state){
            state.loading = false;
        },
        loadError(state, error){
            state.loading = false;
            state.loadError = error;
        },
        setProductsWithSuppliers(state, productsWithSuppliers){
            state.orderSuppliers.productsWithSuppliers = productsWithSuppliers;
        },
        setOrdersProductsComments(state, ordersProductsComments) {
            state.ordersProductsComments = ordersProductsComments;
        },
        setCategoriesWithProducts(state, categoriesWithProducts){
            state.orderSuppliers.categoriesWithProducts = categoriesWithProducts;
        },
        saving(state) {
            state.saving.loading = true;
            state.saving.error = "";
        },
        saveComplete(state) {
            state.saving.loading = false;
        },
        saveError(state, err) {
            state.saving.error = err;
        },
        clearSaveError(state){
            state.saving.error = "";
        },
        clearOrderProductsMutation(state) {
            state.ordersProductsComments = [];
            state.orderProducts = [];
        }
    },
    actions: {
        reset({ state }){
            state.order = {
                Stage: 0
            };
            state.orderProducts = [];
            state.ordersProductsComments = [];
            state.orderSuppliers = {
                updating: false,
                loadError: false,
                productsWithSuppliers: [],
                categoriesWithProducts: []
            };
            state.saving = {
                loading: false,
                error: ""
            };
        },
        loadOrCreateOrder({ commit, dispatch, state }, options){
            commit("loading");

            dispatch("reset");

            dispatch("loadPrerequisteData").then(() => {
                if(!options.orderID){
                    commit("loadComplete");

                    if (options.success) {
                        options.success();
                    }
                    return;
                }

                dispatch("loadOrder", options.orderID).then((loadedOrder) => {
                    for(let property in loadedOrder){
                        if(loadedOrder.hasOwnProperty(property)){
                            state.order[property] = loadedOrder[property];
                        }
                    }

                    if(state.order.Date != null){
                        state.order.Date = util.stripTimeFromDateString(state.order.Date);
                    }

                    dispatch("loadOrderProducts", state.order.ID).then((loadedOrderProducts) => {
                        dispatch("orderDetailsChanged").then(() => {
                            // Group the loaded order products by product id and count total quantity
                            let groupedLoadedOrderProducts = [];
                            for(let i = 0; i < loadedOrderProducts.length; i++){
                                let existingGroup = groupedLoadedOrderProducts.find(gLOP => gLOP.ProductID == loadedOrderProducts[i].ProductID);
                                if(!existingGroup){
                                    groupedLoadedOrderProducts.push({
                                        ProductID: loadedOrderProducts[i].ProductID,
                                        Quantity: loadedOrderProducts[i].Quantity,
                                        Stock: loadedOrderProducts[i].Stock,
                                        Comments: loadedOrderProducts[i].Comments
                                    });
                                    continue;
                                }

                                existingGroup.Quantity += loadedOrderProducts[i].Quantity;
                            }

                            // Update the quantity for each product (this will then determine suppliers)
                            for(let i = 0; i < groupedLoadedOrderProducts.length; i++){
                                dispatch("updateProductQuantity", {
                                    productID: groupedLoadedOrderProducts[i].ProductID,
                                    quantity: groupedLoadedOrderProducts[i].Quantity,
                                });
                            }

                            //// Update the stock for each product
                            for(let i = 0; i < groupedLoadedOrderProducts.length; i++){
                                dispatch("updateProductStock", {
                                    productID: groupedLoadedOrderProducts[i].ProductID,
                                    stock: groupedLoadedOrderProducts[i].Stock
                                });
                            }

                             //Load order products comments with order id and update to order product array
                            dispatch("loadOrderProductsComments", state.order.ID).then((loadedOrderProductsComments) => {
                                commit("setOrdersProductsComments", loadedOrderProductsComments)
                                dispatch("updateOrdersProductCommentToOrder");
                                commit("loadComplete");

                                if (options.success) {
                                    options.success();
                                }
                                
                            }, (err) => {
                                commit("loadError", err);

                                if (options.error) {
                                    options.error();
                                }
                            });

                            
                        }, (err) => {
                            commit("loadError", err);

                            if (options.error) {
                                options.error();
                            }
                        });
                    }, (err) => {
                        commit("loadError", err);

                        if (options.error) {
                            options.error();
                        }
                    });
                   
                }, (err) => {
                    commit("loadError", err);

                    if (options.error) {
                        options.error();
                    }
                });
            }, (err) => {
                commit("loadError", err);

                if (options.error) {
                    options.error();
                }
            });
        },
        loadPrerequisteData({ dispatch }, options){
            return Promise.all([
                dispatch("storeStore/loadStores", null, { root: true }),
                dispatch("departmentStore/loadDepartments", null, { root: true }),
                dispatch("productStore/loadProducts", null, { root: true }),
                dispatch("categoryStore/loadCategories", null, { root: true }),
                dispatch("publicHolidayStore/loadPublicHolidays", null, { root: true }),
                dispatch("supplierStore/loadSuppliers", null, { root: true })
            ]);
        },
        loadOrder(context, orderID){
            return new Promise((resolve, reject) => {
                api.fetchOrders({
                    params: {
                        SearchIDs: JSON.stringify([orderID])
                    },
                    success: function(response) {
                        if(!response.data.Orders || response.data.Orders.length == 0){
                            reject("No order found");
                        }

                        resolve(response.data.Orders[0]);
                    },
                    error: function(e){
                        reject(api.parseHttpRequestError(e));
                    }
                })
            });
        },
        loadOrderProducts(context, orderID){
            return new Promise((resolve, reject) => {
                api.fetchOrderProducts({
                    params: {
                        OrderID: orderID
                    },
                    success: function(response){
                        resolve(response.data.OrdersProducts);
                    },
                    error: function(e){
                        reject(api.parseHttpRequestError(e));
                    }
                })
            });
        },
        loadOrderProductsComments(context, orderID){
            return new Promise((resolve, reject) => {
                api.fetchOrderProductsComments({
                    params: {
                        OrderID: orderID
                    },
                    success: function(response){
                        resolve(response.data.OrdersProductsComments);
                    },
                    error: function(e){
                        reject(api.parseHttpRequestError(e));
                    }
                })
            });
        },
        orderDetailsChanged({ state, commit, dispatch, rootState }, options){
            return new Promise((resolve, reject) => {
                let shouldUpdate = false;

                if(state.orderSuppliers.loadedForStoreID != state.order.StoreID){
                    state.orderSuppliers.loadedForStoreID = state.order.StoreID;
                    shouldUpdate = true;
                }

                if(state.orderSuppliers.loadedForDepartmentID != state.order.DepartmentID){
                    state.orderSuppliers.loadedForDepartmentID = state.order.DepartmentID;
                    shouldUpdate = true;
                }

                if(state.orderSuppliers.loadedForDate != state.order.Date){
                    state.orderSuppliers.loadedForDate = state.order.Date;
                    shouldUpdate = true;
                }

                let haveWhatWeNeed = state.order.StoreID && state.order.DepartmentID && state.order.Date;
                if(!haveWhatWeNeed || !shouldUpdate){
                    resolve();
                    return;
                }

                state.orderSuppliers.updating = true;
                state.orderSuppliers.loadError = false;
                commit("setProductsWithSuppliers", []);
                commit("setCategoriesWithProducts", []);

                // Clear current order products
                dispatch("clearOrderProducts");

                dispatch("storeSupplierStore/loadStoreSuppliers", { storeID: state.order.StoreID }, { root: true }).then(() => {
                    dispatch("orderSuppliersUpdated");

                    resolve();
                }, (err) => {
                    state.orderSuppliers.loadError = true;
                    state.orderSuppliers.updating = false;

                    reject(err);
                });
            });
        },
        orderSuppliersUpdated({ state, rootState, commit }){
            let storeSuppliers = rootState.storeSupplierStore.storeSuppliers;
            let suppliers = rootState.supplierStore.suppliers.filter(s => s.Active);
            let storeID = state.order.StoreID;
            let date = state.order.Date;
            let categories = rootState.categoryStore.categories.filter(c => c.Active).sort(util.sortByName);
            let departmentID = state.order.DepartmentID;
            let products = rootState.productStore.products.filter(p => p.Active).sort(util.sortByName);
            let result = orderUtil.getProductsAndCategories(storeSuppliers, suppliers, storeID, date, categories, departmentID, products);

            commit("setProductsWithSuppliers", result.productsWithSuppliers);
            commit("setCategoriesWithProducts", result.categoriesWithProducts);
            state.orderSuppliers.updating = false;
        },
        updateOrdersProductCommentToOrder({ commit, dispatch, state }) { 
            for(var i = 0; i < state.ordersProductsComments.length; i ++) {
                var order = state.orderProducts.find(orderProduct => {
                    return orderProduct.Product.ID == state.ordersProductsComments[i].ProductID;
                })
               
                if(order && order.Product) {
                    order.Product.Comments =  state.ordersProductsComments[i].Comments;
                }
            }
        },
        updateOrderProductsComments({ commit, dispatch, state }, options) {
            var orderProductsComment = state.ordersProductsComments.find(x => x.ProductID == options.productID);
            var comment = {
                ProductID: options.productID, 
                OrderID: options.orderID, 
                Comments: options.comments
            };

            if(orderProductsComment) {
                orderProductsComment.Comments = options.comments;
            } else {
                state.ordersProductsComments.push(comment)
            }
        },
        updateProductStock({state},options){
            var orderProduct = state.orderProducts.find(x => x.Product.ID == options.productID);
            if(orderProduct){
                orderProduct.Stock = options.stock;
            }
        },
        updateProductQuantity({ state }, options){
            let isPositiveNumber = options.quantity && !isNaN(options.quantity) && options.quantity > 0;
            if(!isPositiveNumber){
                options.quantity = 0;
            } else {
                options.quantity = parseInt(options.quantity);
            }

            // Remove all existng order products for this product
            for(let i = 0; i < state.orderProducts.length; i++){
                let orderProduct = state.orderProducts[i];

                if(orderProduct.Product.ID == options.productID){
                    state.orderProducts.splice(i, 1);
                    i--;
                }
            }

            // Create new order products for the product with the desired quantity
            let product = state.orderSuppliers.productsWithSuppliers.find(p => p.ID == options.productID);
            // If this product is not supplied, do not attempt to give it quantity
            if(!product) {
                return;
            }
            
            let category = state.orderSuppliers.categoriesWithProducts.find(c => c.ID == product.CategoryID);

            // Get the suppliers for the product
            let suppliersRemaining = [].concat(product.Suppliers);
            let quantityRemaining = options.quantity;
            while(quantityRemaining > 0){
                let supplier = suppliersRemaining[0];
                let supplierMaxQuantity = supplier.Quantity;
                let quantity = 0;
                
                // If there are more suppliers, then use up all this supplier's quantity
                if(suppliersRemaining.length > 1){
                    quantity = supplierMaxQuantity;
                // If this is the last supplier, then use up the remaining quantity
                } else {
                    quantity = quantityRemaining;
                }

                // If quantity is null, use all the remaining quantity
                if(quantity == null){
                    quantity = quantityRemaining;
                }

                // Never use more than the remaining quantity
                if(quantity > quantityRemaining){
                    quantity = quantityRemaining;
                }

                suppliersRemaining.splice(0, 1);
                quantityRemaining -= quantity;
                state.orderProducts.push({
                    Product: product,
                    Category: category,
                    Supplier: supplier,
                    Quantity: quantity
                });
            }
        },
        clearOrderProducts({ commit, dispatch, state }){
            commit("clearOrderProductsMutation");
        },
        saveOrder({ commit, dispatch, state }, options) {
            commit("saving");
            
            api.saveOrder(
                options.order,
                {
                    success: function(response) {
                        // the response we get back from this function is the updated order (which will include the changes we requested)
                        if (options.success) {

                            //update comments order id and save them
                            var comments = state.ordersProductsComments.map(c=> {
                                c.OrderID = response.data.Orders[0].ID;
                                return c;
                            })
                            
                            options.success(response.data.Orders[0]);
                            commit("saveComplete");

                            // api.saveOrdersProductsComments(comments, {     
                            //     success: function(_) {
                            //         options.success(response.data.Orders[0]);
                            //     },
                            //     error: function(e) {
                            //         commit("saveError", api.parseHttpRequestError(e));
                
                            //         if (options.error) {
                            //             options.error(e);
                            //         }
                            //     },
                            //     finally: function() {
                            //         commit("saveComplete");
                
                            //         if (options.finally) {
                            //             options.finally();
                            //         }
                            //     }});
                        }
                    },
                    error: function(e) {
                        commit("saveError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        commit("saveComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        clearSaveError({ commit }){
            commit("clearSaveError");
        },
        getTotalQuantity({ state }, productID){

        }
    }
}